import React from 'react';
import FadeInAnimation from './FadeInAnimation';
import './../index.css';

const Section = ({ children, id, className = '', animate = true, ...props }) => {
  const baseClasses = 'section-padding pb-20 pt-5 sm:pt-12 border-foreground scroll-mt-16';
  const combinedClasses = [baseClasses, className].filter(Boolean).join(' ');

  return (
    <FadeInAnimation
      as="section"
      id={id}
      animate={animate}
      className={combinedClasses}
      {...props}
    >
      {children}
    </FadeInAnimation>
  );
};

export default Section;